import type { Components } from "@mui/material/styles";
import { getContrastColor } from "./utils";

export const MuiButton: Components["MuiButton"] = {
  styleOverrides: {
    root: {
      height: "calc(2.5 * var(--rhythm))",
    },
    sizeSmall: {
      height: "calc(2 * var(--rhythm))",
      paddingLeft: "var(--rhythm)",
      paddingRight: "var(--rhythm)",
      fontSize: "var(--font-size-s)",
    },
    sizeMedium: {
      height: "calc(2.5 * var(--rhythm))",
      paddingLeft: "calc(1.25 * var(--rhythm))",
      paddingRight: "calc(1.25 * var(--rhythm))",
      fontSize: "var(--font-size-m)",
    },
    sizeLarge: {
      height: "calc(3 * var(--rhythm))",
      paddingLeft: "calc(1.5 * var(--rhythm))",
      paddingRight: "calc(1.5 * var(--rhythm))",
      fontSize: "var(--font-size-l)",
    },
  },
};

export const MuiToggleButton: Components["MuiToggleButton"] = {
  styleOverrides: {
    root: {
      color: "var(--color-black)",
      "&.MuiButtonBase-root": {
        backgroundColor: "var(--color-white)",
        borderColor: "var(--color-border)",
      },
      "&.MuiToggleButton-primary": {
        "&.Mui-selected": {
          color: getContrastColor(),
          fontWeight: 600,
          backgroundColor: "var(--color-primary)",
        },
      },
    },
    sizeSmall: {
      height: "calc(2 * var(--rhythm))",
    },
    sizeMedium: {
      height: "calc(2.5 * var(--rhythm))",
    },
    sizeLarge: {
      height: "calc(3 * var(--rhythm))",
      fontSize: "var(--font-size-m)",
    },
  },
};
